'use client';

import { Checkbox, FormControlLabel } from '@mui/material';

import { Tooltip } from '../../../atomic-atoms';
import { CheckboxInputProps } from '../types';

export function CheckboxInput(props: CheckboxInputProps) {
  const checkboxColor =
    props.colorVariant === 'green'
      ? 'var(--nn-accent-green)'
      : 'var(--nn-color-primary)';

  const content = (
    <FormControlLabel
      control={
        <Checkbox
          name={props.name}
          checked={props.checked}
          onChange={(e) => props.onChange(e.target.checked)}
          disabled={props.readOnly}
          data-checkbox-color-variant={props.colorVariant ?? 'primary'}
          slotProps={{
            input: {
              'aria-label': props.ariaLabel,
            },
          }}
          sx={{
            '--nn-checkbox-checked-color': checkboxColor,
          }}
        />
      }
      label={props.label}
    />
  );

  if (props.ariaLabel) {
    return <Tooltip title={props.ariaLabel}>{content}</Tooltip>;
  }

  return content;
}
